export default __webpack_public_path__ + "static/media/clairefontaine4.81c24fac.jpg";